module.exports = __webpack_public_path__ + "img/wsczzhjkyypt1.d68a6bac.png";